import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Cookie, X } from 'lucide-react';
import { useLanguage } from '../utils/i18n';
const COOKIE_KEY = 'yb_cookie_consent';
export function CookieConsent() {
  const [visible, setVisible] = useState(false);
  const {
    t
  } = useLanguage();
  useEffect(() => {
    const accepted = localStorage.getItem(COOKIE_KEY);
    if (!accepted) {
      // Delay slightly so it doesn't pop up immediately with preloader
      const t = setTimeout(() => setVisible(true), 3500);
      return () => clearTimeout(t);
    }
  }, []);
  const accept = () => {
    localStorage.setItem(COOKIE_KEY, 'accepted');
    setVisible(false);
  };
  const decline = () => {
    localStorage.setItem(COOKIE_KEY, 'declined');
    setVisible(false);
  };
  return <AnimatePresence data-id="element-141">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 80
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 80
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 30
    }} className="fixed bottom-6 left-4 right-4 md:left-auto md:right-6 md:max-w-sm z-[90] bg-gray-900 text-white rounded-sm shadow-2xl border border-white/10 overflow-hidden" data-id="element-142">
        
          {/* Dark top accent */}
          <div className="h-1 bg-gray-700 w-full" data-id="element-143" />

          <div className="p-5" data-id="element-144">
            <div className="flex items-start gap-3 mb-4" data-id="element-145">
              <div className="bg-white/10 p-2 rounded-sm flex-shrink-0" data-id="element-146">
                <Cookie className="h-5 w-5 text-gray-400" data-id="element-147" />
              </div>
              <div className="flex-1" data-id="element-148">
                <h4 className="font-bold text-sm mb-1" data-id="element-149">{t('cookie_title')}</h4>
                <p className="text-gray-400 text-xs leading-relaxed" data-id="element-150">
                  {t('cookie_desc')}{' '}
                  <span className="text-gray-300 cursor-pointer hover:underline" data-id="element-151">
                    {t('cookie_policy')}
                  </span>
                  .
                </p>
              </div>
              <button onClick={decline} className="text-gray-500 hover:text-white transition-colors flex-shrink-0 -mt-1" aria-label="Закрыть" data-id="element-152">
              
                <X className="h-4 w-4" data-id="element-153" />
              </button>
            </div>

            <div className="flex gap-3" data-id="element-154">
              <button onClick={accept} className="flex-1 bg-white hover:bg-gray-100 text-gray-900 text-xs font-medium uppercase tracking-wide py-2.5 px-4 rounded-sm transition-colors" data-id="element-155">
              
                {t('cookie_accept')}
              </button>
              <button onClick={decline} className="flex-1 bg-white/10 hover:bg-white/20 text-white text-xs font-medium uppercase tracking-wide py-2.5 px-4 rounded-sm transition-colors" data-id="element-156">
              
                {t('cookie_decline')}
              </button>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}